































import BaseLayout from "@/components/layout/BaseLayout.vue"
import {defineComponent, onUnmounted, reactive} from "@vue/composition-api"
import {getLicences, Licence} from "@/data/repos/licences"

export default defineComponent({
  components: {BaseLayout},
  setup() {
    const state = reactive({
      licences: [] as Licence[],
    })

    async function updateLicences() {
      state.licences = await getLicences()
    }

    const intFormatter = new Intl.NumberFormat('en-GB', {
      style: 'decimal',
      useGrouping: true,
    })

    function formatCount(n: number): string {
      if (n === 2147483647) {
        return "Unlimited"
      } else {
        return intFormatter.format(n)
      }
    }

    updateLicences()
    const updateTimer = setInterval(() => updateLicences(), 300 * 1000)
    onUnmounted(() => clearInterval(updateTimer))
    return {state, formatCount}
  },
})
